import React from "react";
import Sidebar from "components/Sidebar";
import { stepsByName } from "../specificUtils/configs";

export default function SidebarWrapper(props) {
  return (
    <Sidebar
      packageTitle="Seleziona periodo"
      contributoInpsLabel=""
      enableTagManager
      onNext={props.onNext}
      sendBookingButtonLabel={props.sendBookingButtonLabel}
      isSubmitting={props.isSubmitting}
      stepsByName={stepsByName}
    />
  );
}
